import React, { useState, useEffect } from "react";
import Article from "../../../components/CommonCompnents/resourcePage/Article";
import "../../../assets/scss/components/home.scss";
import "../../../assets/scss/components/resouces.scss";

import articleImgOne from "../../../assets/images/articleImgOne.png";

import SearchBtnGroup from "../../../components/CommonCompnents/resourcePage/SearchBtnGroup";
import ArticleBanner from "../../../components/CommonCompnents/resourcePage/ArticleBanner";
import Footer from "../Footer";
import { constants } from "../../Constants/commenFeatures";
import { getResoucesContent } from "../../../services/Faqs&Resourse/resource";

const ArticlePage = (props) => {
  const [customResouces, setCustomResouces] = useState([]);
  const [loadMore, setLoadMore] = useState(true);

  const showAllArticles = () => {
    const body = {
      article: {
        pageDate: customResouces
          ? customResouces[customResouces.length - 1].date
          : "",
        pageLimit: constants.Article,
        tag: [],
      },
    };
    getResoucesContent(getResoucesRes, body);
  };

  const getResoucesRes = (res) => {
    if (res && res.data) {
      setLoadMore(true);
      setCustomResouces([...customResouces, ...res.data?.articles]);
    } else if (res && res.error) {
      setLoadMore(false);
    }
  };

  useEffect(() => {
    const body = {
      article: { pageDate: "", pageLimit: constants.Article, tag: [] },
    };
    getResoucesContent(getResoucesRes, body);
  }, []);

  return (
    <div>
      <div className="container">
        <div className="articleDetail-container">
          <div className="back_btn">
            <i class="edel-icon-arrow-left"></i>
            <span onClick={() => props.history.goBack()}>Back</span>
          </div>
          <div className="artical_page">
            <div className="artical_page_title">
              <h2>Articles</h2>
            </div>
            {customResouces &&
              customResouces.map((article) => {
                return article.highlight === true ? (
                  <ArticleBanner img={articleImgOne} article={article} />
                ) : null;
              })}

            <div className="tradingAlgos">
              <div className="article_section_wrap">
                {customResouces &&
                  customResouces.map((article) => {
                    // article.ishighlighted !== true ?
                    console.log("customResouces", article);
                    return (
                      <Article key={article.resourceId} article={article} />
                    );
                  })}
              </div>
            </div>
            {loadMore && (
              <div className="loadIcon">
                <a href="javascript:void(0)" onClick={showAllArticles}>
                  <i className="fa-arrow-down"></i>
                  <span>Load more</span>
                </a>
              </div>
            )}

            {/* <div>
            <div className="resouces_btn_section align_left">
              <p>Search for topics related to</p>
              <SearchBtnGroup />
            </div>
          </div> */}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ArticlePage;
